import type { SxProps } from '@mui/material';
import type { SysTokens } from '@ovComponents/0-tokens/sys/sysTokens';
import { Box } from '@ovComponents/1-primative/box/box';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import type { ReactElement } from 'react';
import { Trans } from 'react-i18next';
import { ExternalLink } from './1-primative/link/externalLink';

export const TransferErrorBanner = ({
  sys,
  i18nKey,
  values,
  supportUrl,
  linkSx,
  components,
  showHeader = true,
}: {
  sys: SysTokens;
  i18nKey: string;
  values?: Record<string, unknown>;
  supportUrl?: string;
  linkSx?: SxProps;
  components?: readonly ReactElement[] | Readonly<Record<string, ReactElement>>;
  showHeader?: boolean;
}) => (
  <Box
    sx={{
      mt: sys.spacing.xl,
      backgroundColor: sys.color.negativeVariant,
      padding: '11px 16px 13px 16px',
      borderRadius: sys.borderRadius.md,
    }}
  >
    {showHeader && (
      <Typography
        variant='bodyMedium'
        weight='bold'
        sx={{ mb: '4px', color: sys.color.negativeOutline }}
      >
        <Trans i18nKey='transfer:withdrawal.withdrawErrorHeader' />
      </Typography>
    )}
    <Typography variant='bodySmall' sx={{ color: sys.color.negativeOutline }}>
      <Trans
        i18nKey={i18nKey}
        values={values}
        components={
          components ?? [<ExternalLink key='0' href={supportUrl} sx={linkSx} />]
        }
      />
    </Typography>
  </Box>
);
